import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["className"];
import React, { forwardRef, memo } from 'react';
import { TimeSeparatorIcon } from '@deliveryhero/armor-icons';
import { ContentSwitcher, ContentSwitcherControl } from '@deliveryhero/armor';
import { useDatePickerTimeSelectorClassNames } from './hooks/useDatePickerTimeSelectorClassNames';
import { useDatePickerTimeSelector } from './hooks/useDatePickerTimeSelector';
import { DatePickerTimeSelectorClock, DatePickerTimeSelectorDayPeriodSelector, DatePickerTimeSelectorInput, DatePickerTimeSelectorRoot } from './style';
import { DATE_PICKER_TIME_SELECTOR_CLASS_PREFIX, DATE_PICKER_TIME_SELECTOR_MODE_AM, DATE_PICKER_TIME_SELECTOR_MODE_PM } from './constants';
/**
 * @internal
 */
export var DatePickerTimeSelector = memo(forwardRef(function DatePickerTimeSelector(_ref, ref) {
  var className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  var classNameComponents = useDatePickerTimeSelectorClassNames(DATE_PICKER_TIME_SELECTOR_CLASS_PREFIX, className);
  var _useDatePickerTimeSel = useDatePickerTimeSelector(props, ref),
    rootProps = _useDatePickerTimeSel.rootProps,
    hourInputProps = _useDatePickerTimeSel.hourInputProps,
    minuteInputProps = _useDatePickerTimeSel.minuteInputProps,
    buttonDayPeriodProps = _useDatePickerTimeSel.buttonDayPeriodProps;
  return React.createElement(DatePickerTimeSelectorRoot, Object.assign({}, rootProps, {
    className: classNameComponents.Root
  }), React.createElement(DatePickerTimeSelectorClock, {
    className: classNameComponents.Clock
  }, React.createElement(DatePickerTimeSelectorInput, Object.assign({}, hourInputProps, {
    className: classNameComponents.InputHours
  })), ' ', React.createElement(TimeSeparatorIcon, {
    small: true,
    className: classNameComponents.TimeSeparatorIcon
  }), ' ', React.createElement(DatePickerTimeSelectorInput, Object.assign({}, minuteInputProps, {
    className: classNameComponents.InputMinutes
  }))), React.createElement(DatePickerTimeSelectorDayPeriodSelector, {
    className: classNameComponents.DayPeriodSelector
  }, React.createElement(ContentSwitcher, Object.assign({}, buttonDayPeriodProps), React.createElement(ContentSwitcherControl, {
    switchName: DATE_PICKER_TIME_SELECTOR_MODE_AM
  }, DATE_PICKER_TIME_SELECTOR_MODE_AM.toUpperCase()), React.createElement(ContentSwitcherControl, {
    switchName: DATE_PICKER_TIME_SELECTOR_MODE_PM
  }, DATE_PICKER_TIME_SELECTOR_MODE_PM.toUpperCase()))));
}));
DatePickerTimeSelector.displayName = DATE_PICKER_TIME_SELECTOR_CLASS_PREFIX;